export enum ScandataLoadStatus {
  NotLoaded = 'NotLoaded',
  Loading = 'Loading',
  LoadingError = 'LoadingError',
  Loaded = 'Loaded',
}

export enum ScandataDisplayStatus {
  Hidden = 'Hidden',
  AwaitingDisplay = 'AwaitingDisplay',
  Displayed = 'Displayed',
  DisplayError = 'DisplayError',
  AwaitingHide = 'AwaitingHide',
}

export enum PointcloudAPIStatus {
  Initializing = 'Initializing',
  Uploaded = 'Uploaded',
  InProgress = 'InProgress',
  Ready = 'Ready',
  Failed = 'Failed',
}

export enum PointcloudStatus {
  Processing = 'Processing',
  Ready = 'Ready',
  Failed = 'Failed',
}
export enum StationStatus {
  NotReady = 'NotReady',
  Ready = 'Ready',
  Error = 'Error',
}

export enum StationLoadStatus {
  NotLoaded = 'NotLoaded',
  Loading = 'Loading',
  LoadingError = 'LoadingError',
  Loaded = 'Loaded',
}

export enum StationDisplayStatus {
  AwaitingDisplay = 'AwaitingDisplay',
  Displayed = 'Displayed',
  DisplayError = 'DisplayError',
}

export enum TilesetFormat {
  Potree = 'potree',
  Cesium = 'cesium',
}

export enum TilesetStatus {
  NotReady = 'NotReady',
  Ready = 'Ready',
  Error = 'Error',
}
